import services from '@/services';
const LOGIN_PATH = '/login';
export default {
    async login(uid, user) {
        const url = `${LOGIN_PATH}/${uid}`
        return await services.post(url, user);
    },

    async getLoginProvider(uid) {
        try {
            const url = `${LOGIN_PATH}/${uid}/providers`
            return await services.get(url);
        } catch (err) {
            console.log(err);
            throw new Error('Provider Not Found');
        }
    },

    async getUserProvidersFromEmail(email) {
        const url = `${LOGIN_PATH}/emails/${email}/providers`
        return await services.get(url);
    },

    async loginWithEmail(email, name, retry, password = null) {
        let url = `${LOGIN_PATH}/emails/codes`;
        if (retry) {
            url += '?retry=true';
        }
        let headers = {};
        if (!!password) {
            headers['password'] = password;
        }
        return await services.post(url, { email, name }, null, headers);
    },

    async confirmEmailCode(code, email) {
        const url = `${LOGIN_PATH}/emails/codes/${code}`
        return await services.post(url, { code, email });
    },

    async loginWithPassword(password, email) {
        const url = `${LOGIN_PATH}/emails/${email}/passwords`
        return await services.post(url, null, null, { password });
    },

    async postActivity(uid) {
        const url = `${LOGIN_PATH}/${uid}/activities`
        return await services.post(url);
    },
    async saveQuestions(questions, uid) {
        const url = `${LOGIN_PATH}/${uid}/questions`;
        return await services.post(url, questions);
    },
    async getToken() {
        return await services.getToken(true);
    },
    async deleteUserConfirmation(uid) {
        const url = `${LOGIN_PATH}/${uid}/exclusions`;
        return await services.post(url, null);
    },

    async saveUserFullName(uid, displayName) {
        const url = `${LOGIN_PATH}/${uid}/names`;
        return await services.postAsync({
            url,
            body: { displayName },
            timeout: 10000,
            hasToken: true
        });
    }
}